import React from 'react';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { Alert } from '../../../../../../CommonComponents/OPL/Alert/Alert';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { useResetToDefaultMutation } from '../../api/useResetToDefaultMutation';

interface Props {
  clientId: string;
  onClose(): void;
}

export const ResetToDefaultModal = ({ clientId, onClose }: Props) => {
  const {
    mutateAsync: resetToDefault,
    isLoading: isResettingToDefault,
    error: resetToDefaultError,
  } = useResetToDefaultMutation({ clientId });

  const handleConfirm = async () => {
    try {
      await resetToDefault({ clientId });

      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal isOpen onRequestClose={onClose} aria={{ labelledby: 'edit-ab--reset-to-default-modal' }}>
      <ModalHeader as="h2" id="edit-ab--reset-to-default-modal" variant="warning">
        Warning
      </ModalHeader>

      <ModalBody as="section">
        {resetToDefaultError && (
          <Alert message={resetToDefaultError.message} variant="error" mb="16" />
        )}

        <Text color="neutral.500">
          All the asset bucketing changes you made will be lost. Are you sure you want to change?
        </Text>
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button onClick={handleConfirm} isLoading={isResettingToDefault} ml="8">
          Confirm Default Asset Bucketing
        </Button>
      </ModalFooter>
    </Modal>
  );
};
